import React from 'react';
import Marquee from 'react-fast-marquee';
import LineImage from '../../assets/img/line-with-dot.svg';
import styled from 'styled-components';

const MarqueeItem = styled.div`
	width: max-content;
	padding: 0 4em;
	text-align: center;
	height: 440px;
	position: relative;

	&:after {
		content: '';
		display: block;
		background: url(${LineImage}) no-repeat;
		height: 300px;
		width: 100px;
		position: absolute;
		left: 93px;
		right: 0;
		bottom: 0;
		margin: auto;
	}

	&:nth-of-type(odd) {
		height: 550px;

		&:after {
			background: url(${LineImage}) no-repeat;
			height: 415px;
		}
	}
`;

const ItemTotal = styled.h2`
	padding: 20px 0 30px;
`;

const ItemType = styled.p``;

const ItemImage = styled.img`
	position: absolute;
	width: 120px;
	height: 120px;
	object-fit: cover;
	border-radius: 5px 5px 0 0;
	bottom: 0;
	left: 0;
	right: 0;
	margin: auto;
	z-index: 9000;
`;

const NumberMarquee = ({list}) => {
	return (
		<Marquee speed="50">
			{list.map((item, index) => (
				<MarqueeItem key={index}>
					<ItemTotal>{item.total.toLocaleString()}</ItemTotal>
					<ItemType>{item.type}</ItemType>
					<ItemImage src={item.image} />
				</MarqueeItem>
			))}
		</Marquee>
	);
};

export default NumberMarquee;
